import { render } from "./AppPhotoSelector.vue?vue&type=template&id=3712d032&scoped=true&ts=true"
import script from "./AppPhotoSelector.vue?vue&type=script&lang=ts"
export * from "./AppPhotoSelector.vue?vue&type=script&lang=ts"

import "./AppPhotoSelector.vue?vue&type=style&index=0&id=3712d032&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3712d032"]])

export default __exports__